import { AnalysisToolbar } from '@modules/analysis/components/AnalysisToolbar';
import { useGetAnalysisSaveActionType } from '@modules/analysis/hooks/useGetAnalysisSaveActionType';
import { useHandleAnalysisBanner } from '@modules/analysis/hooks/useHandleAnalysisBanner';
import { useGetSearchAnalysisActions } from '@modules/feed/components/SearchAnalysisToolbar/hooks';
import { Stack } from '@mui/material';
import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackSearchV2Events = createAnalyticsTracker('searchV2');

export const SearchAnalysisToolbar = () => {
  const { leftActions, rightActions, moreActions } =
    useGetSearchAnalysisActions();

  const actionType = useGetAnalysisSaveActionType();

  const bannerNode = useHandleAnalysisBanner(actionType);

  return (
    <Stack pt={1}>
      <AnalysisToolbar
        leftActions={leftActions}
        rightActions={rightActions}
        moreActions={moreActions}
        bannerNode={bannerNode}
      />
    </Stack>
  );
};
